import React from 'react';
import { useSelector } from 'react-redux';
import { components as Core, toLocalTime, useChartOptions, useTranslation } from '../../../../core';
import * as selectors from '../../../selectors';
import { colors, css, fonts, spacing, StyleSheet } from '../../../../../styles';

export const CancellationChart = () => {
    const { t } = useTranslation();
    const { getLineChart } = useChartOptions();

    const isLoading = useSelector(selectors.isLoadingCancellationChartData);
    const data = useSelector(selectors.getCancellationsChartData);

    const getData = () => [
        [t('period'), t('subscriptionCancellations')],
        ...(data.map(item => [toLocalTime.toLocalDate(item.date), item.count])),
    ];

    return (
        <div className={css(styles.chartContainer)}>
            <Core.Chart
                options={getLineChart()}
                data={getData()}
                chartType="LineChart"
                chartClassName={styles.chart}
                isLoading={isLoading}
            />
        </div>
    )
};

const styles = StyleSheet.create({
    chartContainer: {
        paddingLeft: spacing.s4,
        display: 'flex',
        flex: 1,
        height: 614,
        flexDirection: 'column',
        width: `100%`,
        marginTop: spacing.s8,
        marginBottom: spacing.s8,
        '& svg>g>g:last-child': {
            pointerEvents: 'none'
        },
        '& .google-visualization-tooltip > path': {
            fill: colors.white,
            stroke: colors.grey
        }
    },
    chart: {
        backgroundColor: colors.white,
        borderRadius: spacing.s0,
        boxShadow: `0 1px 6px 0 ${colors.greyOpacity}`,
        overflow: 'hidden',
        height: '100%',
    },
    main: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginBottom: spacing.s3,
        marginTop: spacing.s3
    },
    title: {
        ...fonts.xlNormal,
        color: colors.blackTransparent,
        textAlign: 'center'
    }
});